module.exports = __webpack_public_path__ + "img/Spinner.5f179f95.gif";